var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 103,
    viewBox: "0 0 100 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_752_16193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.7589 22.3272V0.539978H31.1221V82.998H40.2841",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7589 22.3272V0.539978H31.1221V82.998H40.2841",
    stroke: "#333333",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M86.3783 3.92041H34.5023V79.6176H86.3783V3.92041Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9244 31.2228V91.8504H40.284V9.396H77.2776L98.9244 31.2228Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9244 31.2552H77.2776V9.396L98.9244 31.2552Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.08,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.831 21.24H47.4122V25.2972H62.831V21.24Z",
    fill: "#B5BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.587 35.46H47.4122V39.5172H72.587V35.46Z",
    fill: "#B5BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7966 49.6764H47.4122V53.7336H91.7966V49.6764Z",
    fill: "#B5BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7966 63.8964H47.4122V67.9536H91.7966V63.8964Z",
    fill: "#B5BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7966 78.1164H47.4122V82.1736H91.7966V78.1164Z",
    fill: "#B5BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M51.6566 39.5136V30.4524C51.6566 30.4524 48.089 11.7828 31.1366 11.7828V91.89H63.8642C64.0442 91.89 75.2186 84.33 73.5122 55.0008C73.5122 55.0008 58.9142 54.8352 56.8118 51.228V39.5136H51.6566Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5401 41.5872H53.7301V84.528C53.7301 85.4669 53.5452 86.3966 53.1859 87.2641C52.8266 88.1315 52.2999 88.9197 51.636 89.5836C50.9721 90.2475 50.184 90.7741 49.3165 91.1334C48.4491 91.4927 47.5194 91.6776 46.5805 91.6776H7.7005C6.76069 91.679 5.82983 91.4952 4.96115 91.1365C4.09247 90.7778 3.30303 90.2514 2.63799 89.5874C1.97294 88.9233 1.44534 88.1347 1.08536 87.2666C0.725386 86.3984 0.540099 85.4678 0.5401 84.528V41.5872Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8908 35.55C47.8908 30.0457 45.7042 24.7669 41.8121 20.8747C37.92 16.9826 32.6411 14.796 27.1368 14.796C21.6325 14.796 16.3536 16.9826 12.4615 20.8747C8.56937 24.7669 6.38281 30.0457 6.38281 35.55V41.5872H14.9004V35.55C14.9004 32.3038 16.19 29.1905 18.4854 26.895C20.7809 24.5996 23.8942 23.31 27.1404 23.31C30.3867 23.31 33.4999 24.5996 35.7954 26.895C38.0908 29.1905 39.3804 32.3038 39.3804 35.55V41.5872H47.898L47.8908 35.55Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54.522 51.8184C51.7864 50.2359 49.2278 48.3652 46.89 46.2384C46.89 46.2384 37.3356 56.5092 23.2308 55.2996C23.2308 55.2996 23.4576 79.2288 28.6884 88.4916C29.3702 89.6861 30.1506 90.8217 31.0212 91.8864H54.954",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8898 49.5864C46.8898 49.5864 38.3363 58.77 25.7111 57.69C25.7111 57.69 25.9127 79.11 30.5963 87.4008C35.2799 95.6916 46.8898 101.462 46.8898 101.462C46.8898 101.462 58.4998 95.7024 63.1834 87.4008C67.867 79.0992 68.0722 57.69 68.0722 57.69C55.4434 58.77 46.8898 49.5864 46.8898 49.5864Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8901 54.8388C46.8901 54.8388 40.0501 62.2008 29.9305 61.3188C29.9305 61.3188 30.0925 78.2964 33.8437 84.9384C37.5949 91.5804 46.8901 96.21 46.8901 96.21C46.8901 96.21 56.1889 91.5912 59.9365 84.9528C63.6841 78.3144 63.8533 61.3332 63.8533 61.3332C53.7409 62.2008 46.8901 54.8388 46.8901 54.8388Z",
    fill: "url(#paint0_linear_752_16193)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8901 84.9204C52.3637 84.9204 56.8009 80.4832 56.8009 75.0096C56.8009 69.536 52.3637 65.0988 46.8901 65.0988C41.4165 65.0988 36.9793 69.536 36.9793 75.0096C36.9793 80.4832 41.4165 84.9204 46.8901 84.9204Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0117 80.4672L40.8817 76.5L42.4693 74.4444L45.4645 76.7592L50.2417 70.0632L52.3585 71.5716L46.0117 80.4672Z",
    fill: "url(#paint1_linear_752_16193)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3597 51.426H0.5401V81.5184H13.3597V51.426Z",
    fill: "url(#paint2_linear_752_16193)",
    stroke: "#333333",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5401 58.4244H13.3597",
    stroke: "#333333",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5401 66.474H13.3597",
    stroke: "#333333",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5401 74.5236H13.3597",
    stroke: "#333333",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_752_16193",
    x1: 29.9305,
    y1: 75.528,
    x2: 63.8533,
    y2: 75.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B94E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_752_16193",
    x1: 1344.19,
    y1: 2245.23,
    x2: 1710.07,
    y2: 2245.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B94E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_752_16193",
    x1: 0.5401,
    y1: 66.474,
    x2: 13.3597,
    y2: 66.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#05D166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05E163"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_752_16193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99.4644,
    height: 102.074,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.f3a0f704f0afee4031370e5b817e950f.svg";
export { ForwardRef as ReactComponent };